export class ObjectHelpers {
    static mergeObjects<T extends Record<string, any>>(originalInteraction: T, overrides: T) {
        const merged: T = {} as T;

        for (const key in originalInteraction) {
            if (typeof originalInteraction[key] === "object" && typeof overrides[key] === "object") {
                merged[key] = this.mergeObjects(originalInteraction[key], overrides[key]);
            } else {
                merged[key] = originalInteraction[key];
            }
        }

        for (const key in overrides) {
            if (typeof overrides[key] === "object" && typeof originalInteraction[key] !== "object") {
                merged[key] = overrides[key];
            } else if (typeof overrides[key] === "object" && typeof originalInteraction[key] === "object") {
                merged[key] = this.mergeObjects(originalInteraction[key], overrides[key]);
            } else {
                merged[key] = overrides[key];
            }
        }

        return merged;
    }
}
